import { fg } from '@atlaskit/platform-feature-flags';

import { type UIConfig } from '../../../types';

import { initialState } from './initialState';

export const createUIConfig = (config?: Partial<UIConfig>): UIConfig => {
	// Allow fullscreen override for branch deploy testing purposes
	const processedConfig: Partial<UIConfig> | undefined =
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' &&
		fg('rovo_chat_show_local_frontend_components')
			? {
					...config,
					fullScreen: true,
				}
			: config;

	return {
		...{
			...initialState,
			...processedConfig,
			enableSkills: processedConfig?.enableSkills ?? initialState.enableSkills,
			enableAgentMentions: processedConfig?.enableAgentMentions,
			enableAutoSuggest: processedConfig?.enableAutoSuggest ?? initialState.enableAutoSuggest,
			enableBrowserContextBanner:
				processedConfig?.enableBrowserContextBanner ?? initialState.enableBrowserContextBanner,
			disableSettingsModal:
				processedConfig?.disableSettingsModal ?? initialState.disableSettingsModal,
			browserContextSanitizer: processedConfig?.browserContextSanitizer,
			elements: {
				...initialState.elements,
				...processedConfig?.elements,
			},
			promptInputDroppableUrls: processedConfig?.promptInputDroppableUrls,
		},
	};
};
